import React from 'react';

export const variationOfTermsMessages = {
  value: 'Variation of Terms',
  list: [
    {
      value: (
        <>
          Glints may vary these Terms at any time. If Glints varies these Terms,
          it will provide notice by publishing the varied Terms on the Site.
        </>
      ),
    },
    {
      value: (
        <>
          You accept that by doing this, Glints has provided you with sufficient
          notice of the variation to its Terms.
        </>
      ),
    },
  ],
};
